/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateDateTime } from './createDateTime';
import { ExternalKey } from './externalKey';
import { ExternalKeys } from './externalKeys';
import { LastUpdateByUserId } from './lastUpdateByUserId';
import { LocationsListViewAPriceName } from './locationsListViewAPriceName';
import { ProductPriceDetailsViewProduct } from './productPriceDetailsViewProduct';
import { UpdateDateTime } from './updateDateTime';

export interface ProductPriceDetailsView { 
    /**
     * The unique identifier of this record.
     */
    priceId?: number;
    /**
     * A reference to the primary key in the Products Table
     */
    productId?: number;
    /**
     * A reference to the primary key in the PriceNames Table
     */
    priceNameId?: number;
    price?: number;
    promo?: boolean;
    priceRuleId?: number;
    /**
     * This field will accept any date accepted by the javascript function Date.Parse(). You may want to include your timezone e.g. '12 jan 2020 5:30:20 GMT+10:30'
     */
    holdUntil?: Date;
    createDateTime?: CreateDateTime;
    updateDateTime?: UpdateDateTime;
    lastUpdateByUserId?: LastUpdateByUserId;
    externalKeys?: ExternalKeys;
    externalKey?: ExternalKey;
    product?: ProductPriceDetailsViewProduct;
    priceName?: LocationsListViewAPriceName;
}